// @ts-nocheck
import { getCookie } from "@insite/client-framework/Common/Cookies";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import logger from "@insite/client-framework/Logger";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import setSignInOverlayIsOpen from "@insite/client-framework/Store/Components/SignInOverlay/Handlers/SetSignInOverlayIsOpen";
import { getCurrentUserIsGuest, getIsPunchOutSession } from "@insite/client-framework/Store/Context/ContextSelectors";
import cancelPunchOut from "@insite/client-framework/Store/Context/Handlers/CancelPunchOut";
import setShowInventory from "@insite/client-framework/Store/Context/Handlers/SetShowInventory";
import setShowPricing from "@insite/client-framework/Store/Context/Handlers/SetShowPricing";
import signOut from "@insite/client-framework/Store/Context/Handlers/SignOut";
import { getCurrentPage, getLocation } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import { getPageLinkByPageType } from "@insite/client-framework/Store/Links/LinksSelectors";
import setIsReorderConfirmationModalOpen from "@insite/client-framework/Store/Pages/VmiBins/Handlers/SetIsReorderConfirmationModalOpen";
import setNextAction from "@insite/client-framework/Store/Pages/VmiBins/Handlers/SetNextAction";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { useMergeStyles } from "@insite/content-library/additionalStyles";
import { NavigationModeCookieName } from "@insite/content-library/Components/NavigationModeMenu";
import Clickable, { ClickablePresentationProps } from "@insite/mobius/Clickable";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import Icon, { IconPresentationProps } from "@insite/mobius/Icon/Icon";
// import Eye from "@insite/mobius/Icons/Eye"; // Starter Custom Code
// import EyeOff from "@insite/mobius/Icons/EyeOff"; // Starter Custom Code
import User from "@insite/mobius/Icons/User";
import Menu, { MappedLink } from "@insite/mobius/Menu";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography/Typography";
import { HasHistory, withHistory } from "@insite/mobius/utilities/HistoryContext";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
// import React, { useEffect } from "react"; // Starter Custom Code
import { connect, ResolveThunks } from "react-redux";
import { css, ThemeProps, withTheme } from "styled-components";

/* Starter Custom Code - Start */
import { Dictionary } from "@insite/client-framework/Common/Types";
import { FulfillmentMethod } from "@insite/client-framework/Services/SessionService";
import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import changeCustomerContext from "@insite/client-framework/Store/Context/Handlers/ChangeCustomerContext";
import { getCurrentBillToState } from "@insite/client-framework/Store/Data/BillTos/BillTosSelectors";
import loadCurrentBillTo from "@insite/client-framework/Store/Data/BillTos/Handlers/LoadCurrentBillTo";
import loadCurrentShipTo from "@insite/client-framework/Store/Data/ShipTos/Handlers/LoadCurrentShipTo";
import { getCurrentShipToState } from "@insite/client-framework/Store/Data/ShipTos/ShipTosSelectors";
import { WarehouseModel } from "@insite/client-framework/Types/ApiModels";
import FindLocationModal from "@insite/content-library/Components/FindLocationModal";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import LoadingOverlay, { LoadingOverlayProps } from "@insite/mobius/LoadingOverlay";
import Popover, { PopoverPresentationProps } from "@insite/mobius/Popover";
import Radio from "@insite/mobius/Radio";
import RadioGroup, { RadioGroupProps } from "@insite/mobius/RadioGroup";
import getColor from "@insite/mobius/utilities/getColor";
// import constants from "@store/constants"; // Foundation
import HeaderLink, { HeaderLinkStyles } from "@store/Library/Components/Toolkit/HeaderLink";
import Eye from "@store/Library/Components/Toolkit/Icons/Eye/EyeLine";
import EyeOff from "@store/Library/Components/Toolkit/Icons/EyeOff/EyeOffLine";
import PersonFill, { PersonFillOffset } from "@store/Library/Components/Toolkit/Icons/Person/PersonFill";
// import SideMenu, { SideMenuPresentationProps } from "@store/Library/Components/Toolkit/SideMenu"; // Foundation
import AddressInfoDisplay, { AddressInfoDisplayStyles } from "@store/Overrides/Components/AddressInfoDisplay";
import { boxStyles } from "@store/Themes/common/mixins/box";
import { headerHideForMobileStyles } from "@store/Themes/common/mixins/header";
import { addressProps } from "@store/Themes/common/props/address";
import usePreviousExisting from "@toolkit/Framework/Common/Hooks/usePreviousExisting";
import breakpoint from "@toolkit/Framework/Common/Utilities/breakpoint";
import { pxToRem, pxToRemArray } from "@toolkit/Framework/Common/Utilities/unitHelper"; // Foundation
import { IconMap } from "@toolkit/Framework/Types/Icon";
import { gridGapStyles } from "@toolkit/Themes/common/mixins";
import React, { ChangeEvent, useEffect, useRef, useState } from "react";

// Foundation --->
import constants from "@store/constants";
import { useIsSignedInAndhasToBeSignedIn } from "@store/Framework/Store/Context/ContextHooks";
import { useDisplayName } from "@store/Framework/Store/Foundation/Context/ContextHooks";
import ChevronDown from "@store/Library/Components/Icons/ChevronDown";
import { SideMenuStyles } from "@store/Library/Widgets/SignInView";
import { contentSpacingStyles } from "@store/Themes/common/mixins/spacing";
import Button, { ButtonPresentationProps } from "@insite/mobius/Button";
import Hidden from "@insite/mobius/Hidden";
import { getProp } from "@insite/mobius/utilities";
import breakpointMediaQueries, { mediaOptions } from "@insite/mobius/utilities/breakpointMediaQueries";
import SideMenu from "@store/Library/Components/Toolkit/SideMenu";
import { linkStyles } from "@store/Themes/common/mixins/link";
import breakpointValues from "@toolkit/Framework/Common/Utilities/breakpointValues";
// <--- Foundation

const iconMap: Dictionary<IconMap> = {
    user: {
        src: PersonFill,
        offset: PersonFillOffset,
    },
};
/* Starter Custom Code - End */

const enum fields {
    visibilityState = "visibilityState",
    icon = "icon",
    includeAccountMenu = "includeAccountMenu",
    showPricingToggle = "showPricingToggle",
    showInventoryToggle = "showInventoryToggle",
}

const mapStateToProps = (state: ApplicationState) => {
    /* Starter Custom Code - Start */
    const { firstName, lastName, userName } = state.context.session;
    const settings = getSettingsCollection(state);
    const currentUserIsGuest = getCurrentUserIsGuest(state);
    /* Starter Custom Code - End */

    return {
        isSignInPage: getCurrentPage(state).type === "SignInPage",
        userName, // Starter Custom Code
        myAccountPageLink: getPageLinkByPageType(state, "MyAccountPage"),
        signInUrl: getPageLinkByPageType(state, "SignInPage")?.url,
        currentUserIsGuest, // Starter Custom Code
        isPunchOutSession: getIsPunchOutSession(state),
        currentLocation: getLocation(state),
        displayChangeCustomerLink: state.context.session?.displayChangeCustomerLink || false,
        displayPricingAndInventory: state.context.session?.displayPricingAndInventory || false,
        showInventory: state.context.showInventory,
        showPricing: state.context.showPricing,
        isReorderConfirmationModalOpen: state.pages.vmiBins.isReorderConfirmationModalOpen,
        hasChangeLastQty:
            state.pages.vmiBins.selectVmiBinsChangedQty &&
            Object.keys(state.pages.vmiBins.selectVmiBinsChangedQty).length > 0,
        // Starter Custom Code
        // isSignedIn: userName && !currentUserIsGuest, // Foundation
        userDisplayName: firstName ? `${firstName}${lastName ? ` ${lastName}` : ""}` : userName,
        currentBillTo: getCurrentBillToState(state).value,
        currentShipTo: getCurrentShipToState(state).value,
        enableWarehousePickup: settings.accountSettings.enableWarehousePickup,
        fulfillmentMethod: state.context.session.fulfillmentMethod,
        pickUpWarehouse: state.context.session.pickUpWarehouse,
        isAuthenticated: state.context.session.isAuthenticated,
        // Foundation
        allowCreateAccount: getSettingsCollection(state).accountSettings.allowCreateAccount,
    };
};

const mapDispatchToProps = {
    signOut,
    cancelPunchOut,
    setSignInOverlayIsOpen,
    setShowInventory,
    setShowPricing,
    setIsReorderConfirmationModalOpen,
    setNextAction,
    // Starter Custom Code
    loadCurrentBillTo,
    loadCurrentShipTo,
    changeCustomerContext,
};

export interface HeaderSignInStyles {
    signOutWrapper?: InjectableCss;
    titleClickable?: ClickablePresentationProps;
    titleIcon?: IconPresentationProps;
    titleTypography?: TypographyPresentationProps;
    signOutClickable?: ClickablePresentationProps;
    // Starter Custom Code
    headerLink?: HeaderLinkStyles;
    popover?: PopoverPresentationProps;
    sideMenu?: SideMenuStyles; // Foundation
    popoverGridContainer?: GridContainerProps;
    popoverMenuGridItem?: GridItemProps;
    popoverInfoGridItem?: GridItemProps;
    loadingOverlay?: LoadingOverlayProps;
    infoSection?: InjectableCss;
    infoGridContainer?: GridContainerProps;
    infoGridItem?: GridItemProps;
    infoSubtitle?: TypographyPresentationProps;
    addressWrapper?: InjectableCss;
    addressName?: TypographyPresentationProps;
    address?: AddressInfoDisplayStyles;
    addressLink?: LinkPresentationProps;
    fulfillmentRadioGroup?: RadioGroupProps;
    // Foundation
    arrowIcon?: IconPresentationProps;
    signedOutWrapper?: InjectableCss;
    popoverTitle?: TypographyPresentationProps;
    popoverButtons?: ButtonPresentationProps;
}

export const headerSignInStyles: HeaderSignInStyles = {
    signOutWrapper: {
        css: css`
            ${breakpointValues(["none", null, "inline-flex"], "display")}
        `,
    },
    titleClickable: {
        css: css`
            display: flex;
            align-items: center;
            ${linkStyles("primary", "secondary", false, false)}
        `,
    },
    titleIcon: {
        color: "inherit",
        size: 28,
    },
    titleTypography: {
        color: "inherit",
        css: css`
            max-width: ${pxToRem(150)};
            font-weight: ${({ theme }) => theme.design.typography.weight.medium};
        `,
        ellipsis: true,
    },
    signOutClickable: {
        css: css`
            flex: 0 0 auto;
        `,
    },
    popover: {
        wrapperProps: {
            css: css`
                height: 100%;
                ${breakpointValues(["static !important", null, "relative !important"], "position")}
            `,
        },
        contentBodyProps: {
            css: css`
                width: 100%;
                max-height: none;
                box-shadow: ${getProp("theme.shadows.main")};
                color: inherit;
                margin-top: ${pxToRem(1)};

                ${breakpointValues([null, null, pxToRem(220)], "width")}/* Foundation */
            `,
        },
    },
    arrowIcon: {
        color: "inherit",
        size: 28,
        css: css`
            ${props =>
                breakpointMediaQueries(
                    props.theme,
                    [
                        css`
                            width: ${pxToRem(15)};
                            height: ${pxToRem(15)};
                        `,
                        null,
                        null,
                        css`
                            width: ${pxToRem(28)};
                            height: ${pxToRem(28)};
                        `,
                    ],
                    mediaOptions.min,
                )}
        `,
    },
    // Foundation --->
    signedOutWrapper: {
        css: css`
            padding: ${pxToRem(16, 20)};
            ${props =>
                breakpointMediaQueries(
                    props.theme,
                    [
                        null,
                        css`
                            padding: ${pxToRem(16)} 12%;
                        `,
                    ],
                    mediaOptions.max,
                )}
        `,
    },
    popoverTitle: {
        variant: "headerTertiary",
        css: css<any>`
            margin-bottom: ${pxToRem(16)};
            text-align: center;
        `,
    },
    popoverButtons: {
        css: css`
            ${({ theme }) => theme.button?.primary?.css}
            width: 100%;
            ${contentSpacingStyles(0, 0, pxToRem(8))}
        `,
    },
    // <--- Foundation
};

interface OwnProps extends WidgetProps {
    fields: {
        [fields.visibilityState]: string;
        [fields.icon]: string;
        [fields.includeAccountMenu]: boolean;
        [fields.showPricingToggle]: boolean;
        [fields.showInventoryToggle]: boolean;
    };
}

type Props = OwnProps &
    ReturnType<typeof mapStateToProps> &
    ResolveThunks<typeof mapDispatchToProps> &
    HasHistory &
    ThemeProps<BaseTheme>;

let icon: React.ComponentType<IconPresentationProps>;

export const HeaderSignIn = ({
    userName,
    isSignInPage,
    currentUserIsGuest,
    signOut,
    cancelPunchOut,
    fields,
    history,
    myAccountPageLink,
    signInUrl,
    isPunchOutSession,
    currentLocation,
    displayChangeCustomerLink,
    displayPricingAndInventory,
    showInventory,
    showPricing,
    setSignInOverlayIsOpen,
    setShowInventory,
    setShowPricing,
    theme,
    isReorderConfirmationModalOpen,
    hasChangeLastQty,
    setIsReorderConfirmationModalOpen,
    setNextAction,
    // Starter Custom Code
    // isSignedIn, // Foundation
    userDisplayName,
    currentBillTo,
    currentShipTo,
    enableWarehousePickup,
    fulfillmentMethod,
    pickUpWarehouse,
    loadCurrentBillTo,
    loadCurrentShipTo,
    changeCustomerContext,
    isAuthenticated,
    // Foundation
    allowCreateAccount,
}: Props) => {
    const styles = useMergeStyles("headerSignIn", headerSignInStyles);

    useEffect(() => {
        window.onpageshow = function (event) {
            if (event.persisted) {
                window.location.reload();
            }
        };
    }, [userName]);

    /* Starter Custom Code - Start */
    const [isLocationModalOpen, setIsLocationModalOpen] = useState(false);
    const [isLocationModalLoading, setIsLocationModalLoading] = useState(false);
    const [isInfoLoading, setIsInfoLoading] = useState(false);

    const isSignedIn = useIsSignedInAndhasToBeSignedIn(); // Foundation Custom Code
    const displayName = useDisplayName(); // Foundation Custom Code

    const lastBillTo = usePreviousExisting(currentBillTo);
    const lastShipTo = usePreviousExisting(currentShipTo);
    const billTo = currentBillTo || lastBillTo;
    const shipTo = currentShipTo || lastShipTo;

    const elementRef = useRef<HTMLUListElement>(null);
    const popoverRef = useRef<HTMLUListElement>(null);

    const showIconOnly = fields.visibilityState === "icon";

    useEffect(() => {
        if (isAuthenticated && isSignedIn) {
            if (!currentBillTo) {
                loadCurrentBillTo();
            }
            if (!currentShipTo) {
                loadCurrentShipTo();
            }
        }
    }, []);
    /* Starter Custom Code - End */

    if (!myAccountPageLink) {
        return null;
    }

    const { visibilityState, includeAccountMenu, showInventoryToggle, showPricingToggle } = fields;
    const showIcon = visibilityState === "both" || visibilityState === "icon";
    const showLabel = visibilityState === "both" || visibilityState === "label";

    // Foundation Removed - iconMap[fields.icon]

    const currentMode = getCookie(NavigationModeCookieName);
    let menuItems = (myAccountPageLink?.children?.filter(
        pageLink => !(pageLink.type === "ChangeCustomerPage" && !displayChangeCustomerLink),
    ) ?? []) as MappedLink[];

    const getMenuItem = (title: "Inventory" | "Pricing"): MappedLink => {
        return {
            title: title === "Inventory" ? translate("Inventory") : translate("Pricing"),
            iconProps: {
                src: (title === "Inventory" && showInventory) || (title === "Pricing" && showPricing) ? EyeOff : Eye,
                size: 22,
                css: css`
                    margin-left: 20px;
                    margin-right: -12px;
                `,
            },
            clickableProps: {
                css: css`
                    display: flex;
                    text-transform: uppercase;
                `,
                onClick: () => {
                    title === "Inventory"
                        ? setShowInventory({ showInventory: !showInventory })
                        : setShowPricing({ showPricing: !showPricing });
                },
            },
        };
    };

    if (!currentMode || currentMode === "Storefront") {
        menuItems = menuItems?.filter(pageLink => pageLink.type !== "VmiUsersPage");

        // Starter Removed - showInventoryToggle
        // Starter Removed - showPricingToggle
    }

    // Foundation --->
    const closePopover = () => {
        popoverRef.current && (popoverRef.current! as any).closePopover();
    };

    const sideMenuProps = {
        pageType: constants.pageType.myAccount,
        showRootPage: true,
        showSignOut: true,
        stylesOverride: styles.sideMenu,
        onClick: closePopover,
    };

    if (fields.icon === "user") {
        icon = PersonFill;
    }
    // <--- Foundation

    const onSignInHandler = (e: React.MouseEvent) => {
        if ((!userName || currentUserIsGuest) && !isSignInPage) {
            e.preventDefault();

            if (theme.signIn?.useOverlay) {
                setSignInOverlayIsOpen({ isOpen: true });
                return;
            }

            if (!signInUrl) {
                logger.warn("No url was found for SignInPage, defaulting to /SignIn");
                history.push("/MyAccount/SignIn");
            } else {
                const returnUrl = currentLocation.pathname + currentLocation.search;
                if (returnUrl === "/") {
                    history.push(`${signInUrl}`);
                } else {
                    history.push(`${signInUrl}?returnUrl=${encodeURIComponent(returnUrl)}&clientRedirect=true`);
                }
            }
            closePopover();
        }
    };

    const onSignOutHandler = () => {
        if (!isReorderConfirmationModalOpen && hasChangeLastQty) {
            setIsReorderConfirmationModalOpen({ isReorderConfirmationModalOpen: true });
            setNextAction({ nextAction: signOutFunc });
        } else {
            signOutFunc();
        }
    };

    const signOutFunc = () => {
        isPunchOutSession ? cancelPunchOut() : signOut();
    };

    let signInStatusText = translate("Sign In");
    if (userName && !currentUserIsGuest) {
        signInStatusText = userDisplayName; // Starter Custom Code
    }

    /* Starter Custom Code - Start */
    /* Foundation Move Code - closePopover - up */

    const handleChangeFulfillmentMethod = async (event: ChangeEvent<HTMLInputElement>) => {
        setIsInfoLoading(true);
        await changeCustomerContext({ fulfillmentMethod: event.currentTarget.value, pickUpWarehouse });
    };

    const changeWarehouse = () => {
        setIsLocationModalOpen(true);
        closePopover();
    };

    const selectWarehouse = async (pickUpWarehouse: WarehouseModel) => {
        setIsLocationModalLoading(true);
        await changeCustomerContext({ fulfillmentMethod, pickUpWarehouse });
    };

    const closeLocationModal = () => setIsLocationModalOpen(false);
    /* Starter Custom Code - End */

    // Foundation --->
    const onCreateAccountHandler = () => {
        if (!isSignedIn) {
            history.push("/MyAccount/CreateAccount");
            closePopover();
        }
    };
    // <--- Foundation

    // Foundation --->
    const signInButton =
        !fields.includeAccountMenu || !isSignedIn ? (
            <Clickable {...styles.titleClickable} onClick={onSignInHandler} data-test-selector="header_signIn">
                {showIcon && <Icon {...styles.titleIcon} src={icon} />}
                {/* Foundation A11Y - span for accessibility ---> */}
                <Hidden below="lg" as="span">
                    {showLabel && <Typography {...styles.titleTypography}>{signInStatusText}</Typography>}
                </Hidden>
                <Icon {...styles.arrowIcon} src={ChevronDown} />
                {/* <--- Foundation */}
            </Clickable>
        ) : (
            <Clickable {...styles.titleClickable} data-test-selector="header_signIn">
                {showIcon && <Icon {...styles.titleIcon} src={icon} />}
                {showLabel && (
                    // A11Y - span for accessibility
                    <Hidden below="lg" as="span">
                        <Typography {...styles.titleTypography} data-test-selector="header_userName">
                            {displayName}
                        </Typography>
                    </Hidden>
                )}
                <Icon {...styles.arrowIcon} src={ChevronDown} />
            </Clickable>
        );
    // <--- Foundation

    return (
        <StyledWrapper {...styles.signOutWrapper}>
            {/* Foundation -- Menu to Popover ---> */}
            <Popover
                contentBodyProps={{
                    ...styles.popover?.contentBodyProps,
                    as: "div",
                    ref: elementRef,
                }}
                positionFunction={() => {
                    return {
                        position: "absolute",
                        right: 0,
                    };
                }}
                ref={popoverRef}
                insideRefs={[elementRef]}
                popoverTrigger={signInButton /* Foundation */}
            >
                {isSignedIn ? (
                    <SideMenu {...sideMenuProps} />
                ) : (
                    <StyledWrapper {...styles.signedOutWrapper}>
                        <Typography {...styles.popoverTitle}>{translate("Sign In or Create Account")}</Typography>
                        <Button {...styles.popoverButtons} onClick={onSignInHandler}>
                            {translate("Sign In")}
                        </Button>
                        {allowCreateAccount && (
                            <Button buttonType="outline" {...styles.popoverButtons} onClick={onCreateAccountHandler}>
                                {translate("Create Account")}
                            </Button>
                        )}
                    </StyledWrapper>
                )}
            </Popover>
            {/* <--- Foundation  */}
            {/* Foundation Moved Code - Sign in button */}
            {/* Foundation Removed Code - Sign Out */}
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(withHistory(withTheme(HeaderSignIn))),
    definition: {
        displayName: "Header Sign In",
        icon: "arrow-right-to-bracket",
        fieldDefinitions: [
            {
                name: fields.visibilityState,
                displayName: "Settings",
                editorTemplate: "RadioButtonsField",
                options: [
                    {
                        displayName: "Show Icon and Label", // Starter Custom Code
                        value: "both",
                    },
                    {
                        displayName: "Show Label",
                        value: "label",
                    },
                    {
                        displayName: "Show Icon Only", // Starter Custom Code
                        value: "icon",
                    },
                ],
                defaultValue: "both",
                fieldType: "General",
                sortOrder: 1,
            },
            {
                name: fields.icon,
                displayName: "SignIn Icon",
                editorTemplate: "DropDownField",
                options: [
                    {
                        displayName: "User",
                        value: "user", // Starter Custom Code
                    },
                ],
                defaultValue: "user", // Starter Custom Code
                fieldType: "General",
                sortOrder: 2,
            },
            {
                name: fields.includeAccountMenu,
                displayName: "Include My Account Menu",
                editorTemplate: "CheckboxField",
                defaultValue: true,
                fieldType: "General",
                sortOrder: 3,
            },
            // Starter Removed - fields.showPricingToggle
            // Starter Removed - fields.showInventoryToggle
        ],
        group: "Common",
    },
};

export default widgetModule;
